import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AuditorSetup = Loadable(lazy(() => import("./AuditorSetup")));

const auditorSetupRoute = [{ path: "/auditor-setup", element: <AuditorSetup /> }];
export default auditorSetupRoute;
